import { BasketballSwitchRequest } from '@hefe/models';
import { BasketballSwitchRequestsSlice, ModalsSlice } from '@hefe/store';
import { formatDate, formatDateTime, formatTime } from '@hefe/utils';
import { Space, Spin, Typography } from 'antd';
import { t } from '@hefe/i18n';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';
import CustomForm from '../../core/components/form/custom-form';

interface SwitchRequestsSwitchJudgesFormProps {
  request: BasketballSwitchRequest;
  userId: number;
}

export default function SwitchRequestsSwitchJudgesForm(
  props: SwitchRequestsSwitchJudgesFormProps
) {
  const { request, userId } = props;
  const dispatch = useAppDispatch();
  const possibleSwitchGames = useSelector(
    BasketballSwitchRequestsSlice.possibleJudgeGamesSelector
  )[userId];
  const [isLoadingPossibleGames, setLoadingPossibleGames] = useState(false);

  useEffect(() => {
    fetchGames();
  }, []);

  const fetchGames = () => {
    if (possibleSwitchGames) {
      return;
    }

    setLoadingPossibleGames(true);
    dispatch(
      BasketballSwitchRequestsSlice.fetchBasketballUserPossibleJudgeGames(
        userId
      )
    )
      .unwrap()
      .catch(() => null)
      .finally(() => setLoadingPossibleGames(false));
  };

  const onSubmit = (values: any) => {
    const setModalLoading = ModalsSlice.modalsActions.setModalLoading;
    dispatch(setModalLoading(true));

    dispatch(
      BasketballSwitchRequestsSlice.takeOverBasketballJudgeGameSwitchRequest({
        id: request.id,
        user_id: userId,
        switch_game_id: values.game_id,
      })
    )
      .unwrap()
      .then(() => dispatch(ModalsSlice.modalsActions.closeModal()))
      .catch(() => null)
      .finally(() => dispatch(setModalLoading(false)));
  };

  if (isLoadingPossibleGames) {
    return <Spin />;
  }

  return (
    <Space direction="vertical" size={20}>
      <Typography.Text>
        {t('questions.ask_take_over_with_date', {
          date: formatDateTime(request.event_date),
        })}
      </Typography.Text>
      <Typography.Text>
        {t('information_texts.select_possible_event')}
      </Typography.Text>
      <CustomForm
        formId={`switch-request-form-${request.id}`}
        fields={[
          {
            label: t('event'),
            name: 'game_id',
            type: 'select',
            selectOptions: (possibleSwitchGames || [])
              .filter((game) => request.team_id === game.team_id)
              .map((game) => {
                return {
                  label: `${game.label} (${formatDateTime(game.date)})`,
                  value: game.value,
                };
              }),
            rules: [],
          },
        ]}
        onSubmit={onSubmit}
      />
    </Space>
  );
}
